import React, { useState } from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function AreaCharts({ heading, setFilters, chartFilterValues, AreaData, xDataKeyName, DataKeyName, showFilters, colorType, showSelectBox = true, chartHeight=300 }) {

    const handleWise = (e, type) => {
        setFilters((prev) => ({
            ...prev,
            [type]: e
        }))
    }
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>

                    {
                        showFilters ?

                            <div style={{ display: 'flex', gap: '5px' }}>
                                <button className={`customArea-btn ${chartFilterValues?.type == "daily" ? "active" : ""}`} onClick={() => handleWise("daily", "type")}>Daily</button>
                                <button className={`customArea-btn ${chartFilterValues?.type == "weekly" ? "active" : ""}`} onClick={() => handleWise("weekly", "type")}>Weekly</button>
                                <button className={`customArea-btn ${chartFilterValues?.type == "monthly" ? "active" : ""}`} onClick={() => handleWise("monthly", "type")}>Monthly</button>
                                {
                                    showSelectBox ?
                                        <select className='customArea-btn' onChange={(e) => handleWise(e.target.value, "apiType")} value={chartFilterValues?.apiType}>
                                            <option value={""}>Select Api</option>
                                            {
                                                chartFilterValues?.apiList?.length > 0 ? chartFilterValues?.apiList?.map((val, id) => {
                                                    return (
                                                        <option value={val}>{val}</option>
                                                    )
                                                })
                                                    : ""}
                                        </select>
                                        : ""}
                            </div>
                            : ""}
                </div>
                <div>
                   
                    {
                        AreaData?.length > 0 ?
                            <div style={{ height: chartHeight + "px", marginTop: '15px' }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <AreaChart
                                        // style={{ width: '100%', height: "100%" }}
                                        responsive
                                        data={AreaData}
                                        margin={{
                                            top: 20,
                                            right: 5,
                                            left: 5,
                                            bottom: 0,
                                        }}
                                        
                                    >
                                        {
                                            colorType == "green" ?
                                                <defs>
                                                    <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="0.58%" stopColor="rgba(50, 126, 69, 0.73)" />
                                                        <stop offset="50.72%" stopColor="rgba(50, 126, 69, 0.3)" />
                                                        <stop offset="99.41%" stopColor="rgba(255, 255, 255, 0)" />
                                                    </linearGradient>
                                                </defs>
                                                : ""}
                                        {
                                            colorType == "blue" ?
                                                <defs>
                                                    <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="0.58%" stopColor="rgba(66, 164, 199, 0.3)" />
                                                        <stop offset="50.72%" stopColor="rgba(66, 164, 199, 0.3)" />
                                                        <stop offset="99.41%" stopColor="rgba(255, 255, 255, 0)" />
                                                    </linearGradient>
                                                </defs>
                                                : ""}
                                        <CartesianGrid vertical={false} />
                                        <XAxis dataKey={xDataKeyName} axisLine={false} tick = {{fontSize: window.innerWidth >= 1800 ? '19px ' : '14px'}} />
                                        <YAxis axisLine={false} tick = {{fontSize: window.innerWidth >= 1800 ? '19px ' : '14px'}} />
                                        <Tooltip   contentStyle={{ fontSize:  window.innerWidth >= 1800 ? '19px ' : '14px' }} />
                                        <Area type="monotone"
                                            dataKey={DataKeyName}
                                            fill="url(#areaGradient)"
                                            strokeWidth={1}
                                            dot={{
                                                r: 3,
                                                fill: '#ffffff',
                                                stroke: colorType == "green" ? "#327e45ba" : colorType == "blue" ? "#42a4c74d" : "",
                                                strokeWidth: 1
                                            }}
                                            stroke={colorType == "green" ? "#327e45ba" : colorType == "blue" ? "#42a4c74d" : ""}
                                        />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </div>
                            : ""}
                </div>
            </div>
        </>
    )
}
